import React from "react";
import DashboardIcon from "@material-ui/icons/Dashboard";
import DialpadIcon from "@material-ui/icons/Dialpad";
import PermIdentityIcon from "@material-ui/icons/PermIdentity";
import PeopleAltIcon from "@material-ui/icons/PeopleAlt";
import AddLocationIcon from "@material-ui/icons/AddLocation";
import SettingsVoiceIcon from "@material-ui/icons/SettingsVoice";
import GroupWorkIcon from "@material-ui/icons/GroupWork";
import PhoneForwardedIcon from "@material-ui/icons/PhoneForwarded";
import AudiotrackIcon from "@material-ui/icons/Audiotrack";
import MusicVideoIcon from "@material-ui/icons/MusicVideo";
import GraphicEqIcon from "@material-ui/icons/GraphicEq";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import ContactsIcon from "@material-ui/icons/Contacts";
import NotInterestedIcon from "@material-ui/icons/NotInterested";
import PortraitIcon from "@material-ui/icons/Portrait";
import ContactPhoneIcon from "@material-ui/icons/ContactPhone";
import DynamicFeedSharpIcon from "@material-ui/icons/DynamicFeedSharp";
import HeadsetMicIcon from "@material-ui/icons/HeadsetMic";
import DialerSipIcon from "@material-ui/icons/DialerSip";

const menus = [
  {
    key: "/dashboard",
    title: "Dashboard",
    icon: <DashboardIcon className="anticon text-primary" />,
    auth: [1, 2, 3, 4],
  },

  {
    icon: (
      <span className="px-5">
        <hr className="line" />
      </span>
    ),
    auth: [1, 2, 3],
  },

  {
    key: "/numbers",
    title: "Phone Numbers",
    icon: <DialpadIcon className="anticon text-primary" />,
    auth: [1, 2, 3],
    subs: [
      {
        title: "Manage Numbers",
        key: "/numbers/default",
        icon: <ContactsIcon className="anticon text-primary" />,
        auth: [1, 2, 3],
      },
      {
        title: "Block Numbers",
        key: "/numbers/block",
        icon: <NotInterestedIcon className="anticon text-primary" />,
        auth: [3],
      },
    ],
  },
  {
    icon: (
      <span className="px-5">
        <hr className="line" />
      </span>
    ),
    auth: [1, 2, 3],
  },
  {
    icon: <span className="text">PEOPLE</span>,
    auth: [1, 2, 3],
  },

  {
    key: "/companies",
    title: "Companies",
    icon: <PermIdentityIcon className="anticon text-primary" />,
    auth: [1],
  },
  {
    key: "/tenants",
    title: "Tenants",
    icon: <PermIdentityIcon className="anticon text-primary" />,
    auth: [1, 2],
  },
  {
    key: "/endusers",
    title: "Users",
    icon: <PermIdentityIcon className="anticon text-primary" />,
    auth: [1, 2, 3],
  },
  {
    key: "/teams",
    title: "Teams",
    icon: <PeopleAltIcon className="anticon text-primary" />,
    auth: [3],
  },
  {
    key: "/location",
    title: "Locations",
    icon: <AddLocationIcon className="anticon text-primary" />,
    auth: [3],
  },
  {
    icon: (
      <span className="px-5">
        <hr className="line" />
      </span>
    ),
    auth: [1, 2],
  },
  {
    icon: <span className="text">REPORTS</span>,
    auth: [2],
  },
  {
    key: "/user-report",
    title: "User Logs",
    icon: <PortraitIcon className="anticon text-primary" />,
    auth: [2],
  },
  {
    key: "/contact-center-report",
    title: "Contact Center Logs",
    icon: <ContactPhoneIcon className="anticon text-primary" />,
    auth: [2],
  },
  // {
  //   title: "Agent Logs",
  //   key: "/agent-report",
  //   icon: <PieChartIcon className="anticon text-primary" />,
  //   auth: [2],
  // },
  {
    key: "/callpro-report",
    title: "Call Forwarding Logs",
    icon: <PhoneForwardedIcon className="anticon text-primary" />,
    auth: [2],
  },
  {
    key: "/live-status",
    title: "Live Status",
    icon: <DynamicFeedSharpIcon className="anticon text-primary" />,
    auth: [2],
  },
  {
    icon: (
      <span className="px-5">
        <hr className="line" />
      </span>
    ),
    auth: [2],
  },
  {
    icon: <span className="text">APPS</span>,
    auth: [3],
  },
  {
    key: "/voice",
    title: "Voice",
    icon: <SettingsVoiceIcon className="anticon text-primary" />,
    auth: [3],
    subs: [
      {
        icon: <span className="text">REPORTS</span>,
        auth: [3],
      },
      {
        title: "User Logs",
        key: "/voice/user-report",
        icon: <PortraitIcon className="anticon text-primary" />,
        auth: [3],
      },
      {
        title: "Contact Center Logs",
        key: "/voice/contact-center-report",
        icon: <ContactPhoneIcon className="anticon text-primary" />,
        auth: [3],
      },
      // {
      //   title: "Agent Logs",
      //   key: "/voice/agent-report",
      //   icon: <PieChartIcon className="anticon text-primary" />,
      //   auth: [3],
      // },
      {
        title: "Call Forwarding Logs",
        key: "/voice/callpro-report",
        icon: <PhoneForwardedIcon className="anticon text-primary" />,
        auth: [3],
      },
      {
        title: "Live Status",
        key: "/voice/live-status",
        icon: <DynamicFeedSharpIcon className="anticon text-primary" />,
        auth: [3],
      },
      {
        icon: <span className="text">INBOUND</span>,
        auth: [3],
      },
      {
        title: "Contact Center",
        key: "/voice/contact-center",
        icon: <HeadsetMicIcon className="anticon text-primary" />,
        auth: [3],
      },
      {
        title: "Call Forwarding Pro",
        key: "/voice/call-forwarding",
        icon: <PhoneForwardedIcon className="anticon text-primary" />,
        auth: [3],
      },
      // {
      //   title: "Conference",
      //   // key: "/target/manage_target",
      //   icon: (
      //     <FiberManualRecordIcon className="anticon text-primary nested-menu-icon" />
      //   ),
      //   auth: [3, 4],
      // },
      // {
      //   icon: <span className="text">OUTBOUND</span>,
      //   auth: [3, 4],
      // },
      // {
      //   title: "Predictive Dialer",
      //   // key: "/target/create_target",
      //   icon: (
      //     <FiberManualRecordIcon className="anticon text-primary nested-menu-icon" />
      //   ),
      //   auth: [3, 4],
      // },
      // {
      //   title: "Auto Dialer",
      //   // key: "/target/manage_target",
      //   icon: (
      //     <FiberManualRecordIcon className="anticon text-primary nested-menu-icon" />
      //   ),
      //   auth: [3, 4],
      // },
      // {
      //   title: "Call Broadcasting",
      //   // key: "/target/create_target",
      //   icon: (
      //     <FiberManualRecordIcon className="anticon text-primary nested-menu-icon" />
      //   ),
      //   auth: [3, 4],
      // },
      // {
      //   title: "Voicemail Broadcasting",
      //   // key: "voice/voicemail",
      //   icon: (
      //     <FiberManualRecordIcon className="anticon text-primary nested-menu-icon" />
      //   ),
      //   auth: [3, 4],
      // },
      // {
      //   title: "OTP Verification",
      //   // key: "/target/create_target",
      //   icon: (
      //     <FiberManualRecordIcon className="anticon text-primary nested-menu-icon" />
      //   ),
      //   auth: [3, 4],
      // },
      // {
      //   title: "Confirmation Services",
      //   // key: "/target/manage_target",
      //   icon: (
      //     <FiberManualRecordIcon className="anticon text-primary nested-menu-icon" />
      //   ),
      //   auth: [3, 4],
      // },
      {
        icon: <span className="text">PBX Utilities</span>,
        auth: [3],
      },
      {
        key: "/voice/sip-device",
        title: "SIP Devices", 
        icon: (
          <DialerSipIcon className="anticon text-primary" />
        ),
        auth: [3, 4],
      },
      {
        key: "/voice/audio-file",
        title: "Audio Files",
        icon: <AudiotrackIcon className="anticon text-primary" />,
        auth: [3],
      },
      {
        key: "/voice/audio-group",
        title: "Audio Groups",
        icon: <MusicVideoIcon className="anticon text-primary" />,
        auth: [3],
      },
      {
        key: "/voice/music-on-hold",
        title: "Music On Hold",
        icon: <GraphicEqIcon className="anticon text-primary" />,
        auth: [3],
      },
      // {
      //   key: "/voice/voice-mail",
      //   title: "Voice Mail",
      //   icon: (
      //     <FiberManualRecordIcon className="anticon text-primary nested-menu-icon" />
      //   ),
      //   auth: [3, 4],
      // },
    ],
  },

  // {
  //   icon: (
  //     <span className="px-5">
  //       <hr className="line" />
  //     </span>
  //   ),
  //   auth: [3, 4],
  // },
  // {
  //   icon: <span className="text">MESSAGE</span>,
  //   auth: [3, 4],
  // },
  // {
  //   // key: "/voice",
  //   title: "SMS",
  //   auth: [3, 4],
  //   subs: [
  //     {
  //       title: "Multicasting",
  //       // key: "/target/buyer",
  //       icon: (
  //         <FiberManualRecordIcon className="anticon text-primary nested-menu-icon" />
  //       ),
  //       auth: [3, 4],
  //     },
  //     {
  //       title: "SMS Verification",
  //       // key: "/target/create_target",
  //       icon: (
  //         <FiberManualRecordIcon className="anticon text-primary nested-menu-icon" />
  //       ),
  //       auth: [3, 4],
  //     },
  //   ],
  // },
  // {
  //   // key: "/voice",
  //   title: "WhatApps/Telegram",
  //   auth: [3, 4],
  //   subs: [
  //     {
  //       title: "Broadcasting",
  //       // key: "/target/buyer",
  //       icon: (
  //         <FiberManualRecordIcon className="anticon text-primary nested-menu-icon" />
  //       ),
  //       auth: [3, 4],
  //     },
  //     {
  //       title: "Notification",
  //       // key: "/target/create_target",
  //       icon: (
  //         <FiberManualRecordIcon className="anticon text-primary nested-menu-icon" />
  //       ),
  //       auth: [3, 4],
  //     },
  //     {
  //       title: "Advertisement",
  //       // key: "/target/create_target",
  //       icon: (
  //         <FiberManualRecordIcon className="anticon text-primary nested-menu-icon" />
  //       ),
  //       auth: [3, 4],
  //     },
  //     {
  //       title: "Chat Dot",
  //       // key: "/target/create_target",
  //       icon: (
  //         <FiberManualRecordIcon className="anticon text-primary nested-menu-icon" />
  //       ),
  //       auth: [3, 4],
  //     },
  //   ],
  // },
  // {
  //   // key: "/voice",
  //   title: "Chat",
  //   auth: [3, 4],
  //   subs: [
  //     {
  //       title: "Chat Dot",
  //       // key: "/target/buyer",
  //       icon: (
  //         <FiberManualRecordIcon className="anticon text-primary nested-menu-icon" />
  //       ),
  //       auth: [3, 4],
  //     },
  //     {
  //       title: "Customer Services",
  //       // key: "/target/create_target",
  //       icon: (
  //         <FiberManualRecordIcon className="anticon text-primary nested-menu-icon" />
  //       ),
  //       auth: [3, 4],
  //     },
  //   ],
  // },
  // {
  //   icon: (
  //     <span className=" px-5">
  //       <hr className="line" />
  //     </span>
  //   ),
  //   auth: [3, 4],
  // },
  // {
  //   // key: "/voice",
  //   title: "Unified Communication",
  //   auth: [3, 4],
  //   subs: [
  //     {
  //       title: "Astrology",
  //       // key: "/target/buyer",
  //       icon: (
  //         <FiberManualRecordIcon className="anticon text-primary nested-menu-icon" />
  //       ),
  //       auth: [3, 4],
  //     },
  //     {
  //       title: "Virtual Classroom",
  //       // key: "/target/create_target",
  //       icon: (
  //         <FiberManualRecordIcon className="anticon text-primary nested-menu-icon" />
  //       ),
  //       auth: [3, 4],
  //     },
  //     {
  //       title: "Virtual Clinic",
  //       // key: "/target/create_target",
  //       icon: (
  //         <FiberManualRecordIcon className="anticon text-primary nested-menu-icon" />
  //       ),
  //       auth: [3, 4],
  //     },
  //   ],
  // },
  // {
  //   icon: (
  //     <span className="px-5">
  //       <hr className="line" />
  //     </span>
  //   ),
  //   auth: [3, 4],
  // },

  // {
  //   // key: "/dashboard",
  //   title: "Reports",
  //   auth: [3, 4],
  // },
  // {
  //   icon: (
  //     <span className="px-5">
  //       <hr className="line" />
  //     </span>
  //   ),
  //   auth: [3, 4],
  // },
  // {
  //   key: "/call_flow",
  //   title: "Call Flow",
  //   icon: <ApartmentOutlined className="anticon text-primary" />,
  //   auth: [3, 4],
  //   subs: [
  //     {
  //       title: "Manage Call Flows",
  //       key: "/call_flow/manage_call-flows",
  //       icon: (
  //         <FiberManualRecordIcon className="anticon text-primary nested-menu-icon" />
  //       ),
  //       auth: [3, 4],
  //     },
  //     {
  //       title: "Create Call Flows",
  //       key: "/call_flow/create_call-flow",
  //       icon: (
  //         <FiberManualRecordIcon className="anticon text-primary nested-menu-icon" />
  //       ),
  //       auth: [3, 4],
  //     },
  //   ],
  // },
  {
    icon: (
      <span className="px-5">
        <hr className="line" />
      </span>
    ),
    auth: [3],
  },
  {
    key: "/manage_group",
    title: "Manage Groups",
    icon: <GroupWorkIcon className="anticon text-primary" />,
    auth: [3],
    subs: [
      // {
      //   key: "/manage_group/contact",
      //   title: "Contact Groups",
      //   icon: (
      //     <FiberManualRecordIcon className="anticon text-primary nested-menu-icon" />
      //   ),
      //   auth: [3, 4],
      // },
      {
        key: "/manage_group/callerid",
        title: "Outbound CID Groups",
        icon: <GroupAddIcon className="anticon text-primary" />,
        auth: [3],
      },
    ],
  },

  {
    icon: (
      <span className="px-5">
        <hr className="line" />
      </span>
    ),
    auth: [3],
  },
  // {
  //   // key: "/dashboard",
  //   title: "User and Permissions",
  //   auth: [3, 4],
  // },
];

export default menus;
